export enum SimplePopupType {
  Success = "success",
  Warning = "warning",
  Error = "error",
}
